/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'

type VideoSettingsProps = {
    autoPlayState: [boolean, (isAutoPlay: boolean) => void]
    currentSpeedState: [number, (currentSpeed: number) => void]
    scrubbingState: [boolean, (isScrubbing: boolean) => void]
}

export default function VideoSettings({
    autoPlayState: [isAutoPlay, setIsAutoPlay],
    currentSpeedState: [currentSpeed, setCurrentSpeed],
    scrubbingState: [isScrubbing, setIsScrubbing],
}: VideoSettingsProps) {
    return (
        <>
            <button
                type="button"
                {...({
                    popovertarget: 'settings',
                } as React.HTMLAttributes<HTMLButtonElement>)}
                className="video-viz-settings-button video-viz-border"
            >
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    Settings
                </div>
            </button>
            <div
                {...({
                    popover: 'auto',
                } as React.HTMLAttributes<HTMLDivElement>)}
                id="settings"
                style={{
                    maxWidth: '500px',
                    width: '90%',
                    background: 'whitesmoke',
                }}
            >
                <h1>Settings</h1>
                <label
                    className="video-viz-settings-item"
                    htmlFor="autoplay"
                    style={{ fontWeight: 'normal' }}
                >
                    <input
                        type="checkbox"
                        id="autoplay"
                        checked={isAutoPlay}
                        onChange={(e) => setIsAutoPlay(e.target.checked)}
                    />
                    <span style={{ marginLeft: '0.5rem', fontSize: '1.2rem' }}>
                        Autoplay
                    </span>
                    <div>
                        <em style={{ fontSize: '14px', lineHeight: 1 }}>
                            Videos will automatically play. If you have multiple
                            videos in your playlist, they will play back to
                            back.
                        </em>
                    </div>
                </label>
                <label
                    className="video-viz-settings-item"
                    htmlFor="scrubbing"
                    style={{ fontWeight: 'normal' }}
                >
                    <input
                        type="checkbox"
                        id="scrubbing"
                        checked={isScrubbing}
                        onChange={(e) => setIsScrubbing(e.target.checked)}
                    />
                    <span style={{ marginLeft: '0.5rem', fontSize: '1.2rem' }}>
                        Manual
                    </span>
                    <div>
                        <em style={{ fontSize: '14px', lineHeight: 1 }}>
                            Manually control the swing progress. This will turn
                            off if you press play on a given swing
                        </em>
                    </div>
                </label>
                <div className="form-group video-viz-settings-item">
                    <div
                        className="savant-select"
                        data-title="Playback Speed"
                        style={{ width: '100%', maxWidth: 'none' }}
                    >
                        <select
                            id="ddlPlaybackSpeed"
                            value={currentSpeed}
                            onChange={(e) =>
                                setCurrentSpeed(Number(e.target.value))
                            }
                        >
                            <option value="0.05">5%</option>
                            <option value="0.1">10%</option>
                            <option value="0.2">20%</option>
                            <option value="0.5">50%</option>
                            <option value="1">100% (Full Speed)</option>
                        </select>
                    </div>
                    <div>
                        <em style={{ fontSize: '14px', lineHeight: 1 }}>
                            Sets the speed of the swing the first time through
                            the animation.
                        </em>
                        <div>
                            <em style={{ fontSize: '14px' }}>
                                <strong>Warning:</strong> This feature is
                                experimental, and may be buggy
                            </em>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
